import type { Coupon } from '@ixigo/cab-core/coupon';
import type { BaseCabItemOption, RideDetails } from '@/api';
import { getCabAttributes } from '@/components/cab-selection';
import { getCommonSearchAttributes } from '@/components/search-form';

export interface BookingTrackingData {
	rideDetails: RideDetails;
	coupon?: Pick<Coupon, 'couponCode' | 'benefits'>;
	selection?: BaseCabItemOption;
}

export const bookingEventTransformers = {
	rideDetails: (rideDetails: RideDetails) =>
		getCommonSearchAttributes({
			pickup: rideDetails.pickup.location,
			drop: rideDetails.drop.location,
			pickupTime: rideDetails.pickup.dateTime.time,
		}),
	coupon: (coupon: Pick<Coupon, 'couponCode' | 'benefits'>) => ({
		'Coupon Code': coupon.couponCode,
		Discount: coupon.benefits.instantDiscount,
	}),
	selection: (selection: BaseCabItemOption) => getCabAttributes(selection),
};

export function getBookingAttributes(booking: BookingTrackingData) {
	return {
		...bookingEventTransformers.rideDetails(booking.rideDetails),
		...(booking.coupon ? bookingEventTransformers.coupon(booking.coupon) : {}),
		...(booking.selection
			? bookingEventTransformers.selection(booking.selection)
			: {}),
	};
}
